import ModelInterface from '@/models/ModelInterface';
import {RawResp, Ans} from 'src/types/entity/RawResp'
import {DateTime} from 'luxon';
import {millisToFormat} from '@/lib/date'

import {
  RESP_STATUS_BLANK,
  RESP_STATUS_FILLED,
  RESP_STATUS_EXPIRED
} from '@/constants';

// @ts-ignore
import messages from '@/lang/index'

interface IStatuses {
  [key: string]: {label: string, bgColor: string, color: string};
}

const STATUSES: IStatuses = {
  [RESP_STATUS_BLANK]: {label: messages.polls.statuses.active, bgColor: '#FEEDC2', color: '#E6AB45'},
  [RESP_STATUS_FILLED]: {label: messages.polls.statuses.filled, bgColor: '#DFF3DD', color: '#15BF51'},
  [RESP_STATUS_EXPIRED]: {label: messages.polls.statuses.expired, bgColor: '#f4f4f5', color: '#909399'},
  unknown: {label: messages.polls.statuses.unknown, bgColor: '#f4f4f5', color: '#909399'},
};

class Resp extends ModelInterface<RawResp> {
  constructor (data: RawResp) {
    super(data);
  }

  public getPollTitle () {
    return this.data.poll && this.data.poll.title;
  }

  public getPollDescr () {
    return this.data.poll && this.data.poll.descr;
  }

  public getPollQuests () {
    return this.data.poll && this.data.poll.quests;
  }

  public getAns () {
    return this.data.ans || []
  }

  public getQuestAns (qid: string): Ans | undefined {
    return this.getAns().find(ans => ans.qid === qid)
  }

  public getStatus () {
    return this.data.status || 'unknown';
  }

  public getStatusLabel (status?: string) {
    if (status) {
      return STATUSES[status].label || messages.polls.statuses.unknown;
    } else {
      return STATUSES[this.getStatus()].label;
    }
  }

  public getStatusColor (status?: string) {
    if (status) {
      return STATUSES[status].color || '#000';
    } else {
      return STATUSES[this.getStatus()].color;
    }
  }

  public getStatusBgColor (status?: string) {
    if (status) {
      return STATUSES[status].bgColor || '#000';
    } else {
      return STATUSES[this.getStatus()].bgColor;
    }
  }

  public getCt () {
    return this.data.ct || 0
  }


  get pollTitle () {
    return this.getPollTitle();
  }

  get ctDate () {
    return millisToFormat(this.getCt())
  }

  get status () {
    return this.getStatus();
  }

  get isFilled (): boolean {
    return this.getStatus() === RESP_STATUS_FILLED;
  }


  // public getDescription () {
  //   return this.data.descr;
  // }

  // public getQuests () {
  //   return this.data.quests;
  // }
  // public getStatus () {
  //   if (this.data.status === POLL_STATUS_OPEN) {
  //     if (this.getSendAt() && this.getSendAt()! < DateTime.local().toMillis() && this.data.mailing.status === MAILING_STATUS_READY) {
  //       return MAILING_STATUS_BEFORE_PROGRESS;
  //     } else {
  //       return this.data.mailing.status;
  //     }
  //   } else {
  //     return this.data.status;
  //   }
  // }

  // public getSendAt () {
  //   return this.data.mailing.send_at;
  // }

  // public getFinishAt () {
  //   return this.data.finish_at;
  // }

  // public getSentErr () {
  //   return this.data.mailing.sent_err;
  // }

  // public getSentOk () {
  //   return this.data.mailing.sent_ok;
  // }

  // public getRcptNum () {
  //   return this.data.mailing.rcpt_num;
  // }

  // public getMsgrNum () {
  //   return this.data.mailing.msgr_num || 0;
  // }

  // public getSendProgress (): number {
  //   let progress = ((this.getSentOk() + this.getSentErr()) / this.getRcptNum()) * 100;
  //   return Math.round(progress);
  // }

  // public getStatusLabel (status?: string) {
  //   if (status) {
  //     return STATUSES[status].label || messages.polls.statuses.unknown;
  //   } else {
  //     return STATUSES[this.getStatus()].label;
  //   }
  // }

  // public getStatusColor (status?: string) {
  //   if (status) {
  //     return STATUSES[status].color || '#000';
  //   } else {
  //     return STATUSES[this.getStatus()].color;
  //   }
  // }

  // public getStatusBgColor (status?: string) {
  //   if (status) {
  //     return STATUSES[status].bgColor || '#000';
  //   } else {
  //     return STATUSES[this.getStatus()].bgColor;
  //   }
  // }

  // public getCt () {
  //   return this.data.ct;
  // }

  // public getTs () {
  //   return this.data.ts;
  // }

  // public getFilter () {
  //   return this.data.mailing.filter || {};
  // }

  // get title () {
  //   return this.getTitle();
  // }

  // get status () {
  //   return this.getStatus();
  // }

  // get rcpt_num () {
  //   return this.getRcptNum();
  // }

  // get answ_num () {
  //   return 0;
  // }

  // get send_at_date () {
  //   if (this.getSendAt()) {
  //     return millisToFormat(this.getSendAt() as number)
  //   } else {
  //     return messages.polls.not_specified
  //   }
  // }

  // get finish_at_date () {
  //   if (this.getFinishAt()) {
  //     return millisToFormat(this.getFinishAt() as number)
  //   } else {
  //     return messages.polls.not_specified
  //   }
  // }

  // get ct_date () {
  //   return millisToFormat(this.getCt())
  // }
}

export default Resp;